// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class ControllerVersionInfoMessage implements flatbuffers.IUnpackableObject<ControllerVersionInfoMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ControllerVersionInfoMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsControllerVersionInfoMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ControllerVersionInfoMessage,
  ): ControllerVersionInfoMessage {
    return (obj || new ControllerVersionInfoMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsControllerVersionInfoMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ControllerVersionInfoMessage,
  ): ControllerVersionInfoMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ControllerVersionInfoMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  car(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  version(): string;
  version(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  version(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startControllerVersionInfoMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addCar(builder: flatbuffers.Builder, car: number) {
    builder.addFieldInt32(0, car, 0);
  }

  static addVersion(builder: flatbuffers.Builder, versionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, versionOffset, 0);
  }

  static endControllerVersionInfoMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // version
    return offset;
  }

  static createControllerVersionInfoMessage(
    builder: flatbuffers.Builder,
    car: number,
    versionOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ControllerVersionInfoMessage.startControllerVersionInfoMessage(builder);
    ControllerVersionInfoMessage.addCar(builder, car);
    ControllerVersionInfoMessage.addVersion(builder, versionOffset);
    return ControllerVersionInfoMessage.endControllerVersionInfoMessage(builder);
  }

  unpack(): ControllerVersionInfoMessageT {
    return new ControllerVersionInfoMessageT(this.car(), this.version());
  }

  unpackTo(_o: ControllerVersionInfoMessageT): void {
    _o.car = this.car();
    _o.version = this.version();
  }

  unpackFields(...fields: string[]): ControllerVersionInfoMessageT {
    const t = new ControllerVersionInfoMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("car")) {
      t.car = this.car();
    }
    if (fieldSet.has("version")) {
      t.version = this.version();
    }
    return t;
  }
}

export class ControllerVersionInfoMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public car: number = 0,
    public version: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.version === null || this.version === undefined) {
      throw new Error('Required field "version" is not set');
    }
    const version = this.version !== null ? builder.createString(this.version!) : 0;

    return ControllerVersionInfoMessage.createControllerVersionInfoMessage(
      builder,
      this.car,
      version,
    );
  }

  clone(): ControllerVersionInfoMessageT {
    const obj = new ControllerVersionInfoMessageT();
    obj.car = this.car;
    obj.version = this.version;
    return obj;
  }

  equals(other: ControllerVersionInfoMessageT): boolean {
    if (this.car !== other.car) return false;
    if (this.version !== other.version) return false;
    return true;
  }
}

export function verifyControllerVersionInfoMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "version");
  } finally {
    verifier.popDepth();
  }
}
